<script setup lang="ts">
import { useLegalAccountFormState } from '../../../../utilities/account/useAccountFormLegal'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import BaseInputText from '../../../base/BaseInputText.vue'
import { ReceiptTaxIcon } from '@heroicons/vue/solid'
import {
    getFieldRulesLegal,
    getTinValidationRules,
    isRequiredLegalProfileAttributesForInvestment,
    isRequiredRequiredLegalProfileAttributes,
} from '../../../../validation'
import LegalTaxResidenciesFields from '../../../wizard/ESAC/legal/form/fields/LegalTaxResidenciesFields.vue'
import { getPlatformSettings } from '../../../../utilities/usePlatformSettings'
import { useForm } from 'vee-validate'
import { onMounted, onUnmounted } from 'vue'

const { legalProfile } = useLegalAccountDataState()
function isTaxResidenciesActivated() {
    return getPlatformSettings().compliance_profile === 'esac'
}

const { legalProfile: legal_account } = useLegalAccountDataState()

const form = useForm({
    validationSchema: {
        'legal_account.tax_number': getFieldRulesLegal('tax_number', ['min:2', 'max:255']),
        'tin': getTinValidationRules(),
    },
    initialValues: { legal_account, tin: legal_account.tax_residencies },
})
const formState = useLegalAccountFormState()

onMounted(() => {
    // @ts-ignore
    formState.currentForm = form
})
onUnmounted(() => {
    formState.currentForm = null
})
</script>

<template>
    <LegalTaxResidenciesFields v-if="isTaxResidenciesActivated()" v-model="legalProfile"></LegalTaxResidenciesFields>
    <div v-else class="grid grid-cols-1 gap-x-4 gap-y-8 px-4 py-5 sm:grid-cols-2 sm:px-6">
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.tax_number"
                :icon="ReceiptTaxIcon"
                :required="isRequiredRequiredLegalProfileAttributes('tax_number')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('tax_number')"
                name="legal_account.tax_number"
                :label="$t('legal_account.tax_number')" />
        </div>
    </div>
</template>
